"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AudienceList = void 0;
var _List = require("../../../../../../../Data/List");
var _hooks = require("../../../../../../../hooks");
var _AudiencePicker = require("../../../../../AudiencePicker.helpers");
var _AudiencePickerProvider = require("../../../../../provider/AudiencePickerProvider.helpers");
var _AudienceListItem = require("./partials/AudienceListItem");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
const AudienceList = props => {
  const {
    audienceIds,
    selectedAudienceIds = [],
    readOnlyMapper,
    mapper,
    audienceType,
    selectedClassesIds,
    selectedGroupsIds,
    selectedStudentsIds,
    isReadOnly,
    onDisableItemClick,
    onDeleteItem,
    onSelectedChanged,
    setCantRemoveMessage,
    searchedStudentsData,
    originalSelectedGroupsIds,
    originalSelectedClassesIds,
    originalSelectedStudentsIds
  } = props;
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const handleDisabledItemClick = () => {
    if (onDisableItemClick) {
      setCantRemoveMessage(onDisableItemClick());
    }
  };
  const unSelectedIds = audienceIds?.filter(id => selectedAudienceIds && selectedAudienceIds.indexOf(id) < 0);
  let ids = isMobileView ? audienceIds : unSelectedIds;
  if (!ids) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_List.List, {
    id: audienceType,
    children: ids.map((id, i) => {
      const isItemReadonly = isReadOnly || readOnlyMapper[id];
      const isSelected = Boolean(selectedAudienceIds && selectedAudienceIds.indexOf(id) >= 0);
      const selected = audienceType === 'students' ? {
        selectedClassesIds,
        selectedGroupsIds,
        selectedStudentsIds: (0, _AudiencePicker.getSelectedIds)(selectedAudienceIds, isSelected, id)
      } : audienceType === 'groups' ? {
        selectedClassesIds,
        selectedStudentsIds,
        selectedGroupsIds: (0, _AudiencePicker.getSelectedIds)(selectedAudienceIds, isSelected, id)
      } : {
        selectedStudentsIds,
        selectedGroupsIds,
        selectedClassesIds: (0, _AudiencePicker.getSelectedIds)(selectedAudienceIds, isSelected, id)
      };
      const handleChange = () => {
        const originalAudience = audienceType === 'students' ? originalSelectedStudentsIds : audienceType === 'groups' ? originalSelectedGroupsIds : originalSelectedClassesIds;
        const currentAudience = audienceType === 'students' ? selected.selectedStudentsIds : audienceType === 'groups' ? selected.selectedGroupsIds : selected.selectedClassesIds;
        if (onDeleteItem && !(0, _AudiencePicker.checkSubset)(currentAudience ?? [], originalAudience ?? [])) {
          setCantRemoveMessage(onDeleteItem());
        }
        onSelectedChanged(selected);
      };
      const fullNameHtml = searchedStudentsData && searchedStudentsData.filter(student => student.id === id)[0].fullNameHtml;
      const fullName = fullNameHtml || mapper && (0, _AudiencePickerProvider.getStudentFullName)(mapper[id]?.student);
      return /*#__PURE__*/(0, _react.createElement)(_AudienceListItem.AudienceListItem, {
        ...props,
        key: id,
        id: id,
        isSelected: isSelected,
        isItemReadonly: isItemReadonly,
        audienceType: audienceType,
        fullName: fullName,
        onChange: handleChange,
        onDisabledItemClick: handleDisabledItemClick
      });
    })
  });
};
exports.AudienceList = AudienceList;